import React, { useState } from 'react';

const SessionContext = React.createContext({
  collapsed: undefined
});
const { Provider, Consumer } = SessionContext;

const SessionProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState();

  return (
    <Provider
      value={{
        collapsed,
        setCollapsed
      }}
    >
      {children}
    </Provider>
  );
};

export default SessionContext;
export { SessionProvider, Consumer as SessionConsumer };
